import { IStrategyInstanceStatus } from "@pulse-ui/codegen/generated_ts/managed_algo";
import { IAGAlgoDataRow } from "../AlgoTable.types";

type StrategyInstancesResponse = Record<string, IStrategyInstanceStatus>;

export const mapRowData = (strategyInstancesResponse: StrategyInstancesResponse | null | undefined): IAGAlgoDataRow[] => {
    if (!strategyInstancesResponse || typeof strategyInstancesResponse !== 'object') {
        return [];
    }

    const rows: IAGAlgoDataRow[] = [];

    for (const connectionId in strategyInstancesResponse) {
        const strategyInstance = strategyInstancesResponse[connectionId];

        if (!strategyInstance?.strategy_instance_states?.length) {
            continue;
        }

        const instanceRows = strategyInstance.strategy_instance_states.map((instanceState): IAGAlgoDataRow => ({
            id: `${connectionId}-${instanceState.strategy_instance_id}`,
            connection_id: connectionId,
            type: strategyInstance.algo_name,
            portfolio: instanceState.portfolio_id || '-',
            pnl: instanceState.pnl?.toString() || '-',
            status: instanceState.status?.toString() || '-',
            cpu_usage: '-',
            ram_usage: '-',
            strategy: instanceState.strategy_id || '-',
            strategy_instance_id: instanceState.strategy_instance_id || '-',
            accounts: instanceState.account_ids || [],
            create_time: instanceState.create_time || '-',
            update_time: instanceState.update_time || '-',
            original_data: instanceState,
            visible_parameters: strategyInstance.visible_parameters || [],
        }));

        rows.push(...instanceRows);
    }

    return rows;
};